import { FC } from 'react';
import { PodcastHighlightedProps } from './types';
import {
  BackgroundImage,
  Flex,
  Overlay,
  Stack,
  Text,
  Title,
} from '@mantine/core';
import { NEWS_HEADER_IMAGE } from 'src/mockdata';
import { useRouter } from 'next/router';
import { ShareIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'next-i18next';

export const PodcastHighlighted: FC<PodcastHighlightedProps> = ({
  podcast,
  handleSharePodcast,
}) => {
  const router = useRouter();

  const { t } = useTranslation(['podcast', 'dashboard']);

  const handleClickPodcast = () => {
    router.push(`/podcasts/${podcast?.slug}`);
  };

  const isPodcastPage = router.pathname !== '/podcasts';

  return (
    <BackgroundImage
      style={{ cursor: 'pointer' }}
      src={podcast?.header_image?.key ?? NEWS_HEADER_IMAGE}
      radius="md"
      w="100%"
      h={500}
    >
      <Overlay
        onClick={() => {
          if (!isPodcastPage) {
            return handleClickPodcast();
          }
          handleSharePodcast?.();
        }}
        w="100%"
        h={500}
        zIndex={10}
        pos="relative"
        opacity={0.85}
        radius="md"
        gradient="linear-gradient(145deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 100%)"
      >
        <Flex
          p={{ md: 40 }}
          gap="lg"
          direction="column"
          h="100%"
          justify={isPodcastPage ? 'space-between' : 'end'}
        >
          {isPodcastPage && (
            <Flex justify="end" gap={16} p={{ base: 20, md: 0 }} align="center">
              <Text variant="caption2White" component="span">
                {t('podcast.share')}
              </Text>
              <ShareIcon color="white" width={16} />
            </Flex>
          )}

          <Stack p={20}>
            <Title lineClamp={8} variant="h2White" maw={600}>
              {podcast?.title}
            </Title>
            <Text lineClamp={5} variant="body3White" maw={800}>
              {podcast?.description}
            </Text>
          </Stack>
        </Flex>
      </Overlay>
    </BackgroundImage>
  );
};
